import {Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[appSocialSecurityInput]'
})
export class SocialSecurityInputDirective {
  private maxLength = 11;

  constructor(el: ElementRef) {
    el.nativeElement.addEventListener('keydown', (event) => {
      console.log('Key pressed: ' + event.key);
      const exclude = /Backspace|Enter|Tab|Delete|Del|ArrowUp|Up|ArrowDown|Down|ArrowLeft|Left|ArrowRight|Right/;
      const regex = RegExp('[0-9]');
      if (!regex.test(event.key) && !exclude.test(event.key)) {
        event.preventDefault();
      }

      let str: string = event.target.value;

      if (str.length >= this.maxLength && !exclude.test(event.key)) {
        event.preventDefault();
      } else {
        const isFirstDashPlaced = str.indexOf('-', 3);
        if (str.length > 2 && isFirstDashPlaced === -1 && !exclude.test(event.key)) {
          el.nativeElement.value += '-';
          str += '-';
        }

        const isSecondDashPlaced = str.indexOf('-', 6);
        if (str.length > 5 && isSecondDashPlaced === -1 && !exclude.test(event.key)) {
          el.nativeElement.value += '-';
          str += '-';
        }
      }
    });
  }
}
